import { useI18n } from '@whizz/react-i18n';
import type { HighlightedProps } from '../../types';
import type { ChartIconType } from '../../../components/charts/types';
import type { TopicChartType } from '../../../mapper/groupTopicReportMapper';
import { SectionLayout } from '../modules';
import { TopicProgress as TopicProgressChart } from '../../../components';
import TrackVisibility from 'react-on-screen';

type Props = {
  chartTopicProgress: TopicChartType[],
  showOthersData: boolean,
  iconToUse: ChartIconType
} & HighlightedProps;

const SchoolTopicProgress = ({
  chartTopicProgress,
  showOthersData,
  iconToUse,
  highlightedLabel,
  highlightedIds,
}: Props): JSX.Element => {
  const { translate } = useI18n();

  return (
    <SectionLayout
      title={translate('pages.REPORTS.SECTIONS.TOPIC_PROGRESS.title')}
      highlightLabel={highlightedLabel}
      moreInfo={translate('pages.REPORTS.SECTIONS.TOPIC_PROGRESS.info_school', { 'interpolation': { 'escapeValue': false } })}
      canBeExpanded={false}
      id={'school-topic-progress-container'}
    >
      <TrackVisibility partialVisibility>
        {({ isVisible }) => (
          <TopicProgressChart
            showOthersData={showOthersData}
            topics={chartTopicProgress}
            highlightedIds={highlightedIds}
            type={iconToUse}
            play={isVisible}
          />)}
      </TrackVisibility>
    </SectionLayout>
  );
};

export default SchoolTopicProgress;
